import gql from 'graphql-tag';

export default gql`
  mutation networkUpdateVendorsMutation($input: NetworkUpdateVendorsInput) {
    networkUpdateVendors(input: $input)
  }
`;
